import { createSelector } from '@reduxjs/toolkit';
import { selfMsgSelector } from './self';

const pageInfoSelector = createSelector(selfMsgSelector, (messages) => messages.pageInfo);

export default pageInfoSelector;
